/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export const DRAG_DROP_TRANSFER_KEY = "condition-key";
export const DRAG_DROP_TRANSFER_CONTENT = "condition-content";
//# sourceMappingURL=AbBooleanLogicTreeDragDrop.js.map
